const cascoResources = {
  en: {
    casco: {
      insured_amount_must_be: 'The insured amount must be at least',
      insured_amount: 'Insured amount',
      real_value: 'Actual vehicle value',
      program: 'Program',

      title: 'CASCO car insurance',
      calculator: 'Insurance calculator',
      'description.title': 'Description',
      'description.text':
        'Vehicle insurance is always profitable! Vehicle owner has a bunch of risks that do not depend on the driver’s driving skills and his experience. While availability policy CASCO you not have to pay expenses, damage will be covered by insurance company.',
      vip: 'Программа 1',
      vipHtml: `<p><span style="font-weight: 700;">На страхование принимается</span>&nbsp;легковой транспорт не
        старше 11 лет</p>
      <p><span style="font-weight: 700;">Страховым случаем является</span>&nbsp;риск утраты (гибели) или
        повреждения ТС в результате:</p>
      <ul>
        <li id="pr_ul11">дорожно-транспортное происшествие (ДТП)</li>
        <li id="pr_ul12">
          противоправные действия третьих лиц</li>
        <li id="pr_ul13">
          стихийные бедствия</li>
        <li id="pr_ul14">
          иные непредвиденные события</li>
        <li id="pr_ul15">
          случайное внешнее воздействие химических веществ/высокой температуры</li>
      </ul>
      <p><span style="font-weight: 700;">Дополнительные условия по программе</span></p>
      <ul>
        <li>при частичном повреждении размер ущерба определяется на основании счета, предоставленного специализированной СТО, являющейся официальным дилером, входящим в группу компаний «Астана Моторс», при этом амортизационный износ транспортного средства в расчет не принимается.</li>
      </ul>
      <p><span style="font-weight: 700;">Срок действия Договора</span>&nbsp;12 месяцев, до исчерпания
        страховой суммы</p>`,
      economy: 'Программа 2',
      economyHtml: `<p><strong>На страхование принимается</strong> легковой транспорт не старше 11 лет</p>
      <p><span style="font-weight: 700;">Страховым случаем является</span>&nbsp;риск утраты (гибели) или
        повреждения ТС в результате:</p>
      <ul>
        <li id="pr_ul11">дорожно-транспортное происшествие (ДТП)</li>
        <li id="pr_ul12">
          противоправные действия третьих лиц</li>
        <li id="pr_ul13">
          стихийные бедствия</li>
        <li id="pr_ul14">
          иные непредвиденные события</li>
        <li id="pr_ul15">
          случайное внешнее воздействие химических веществ/высокой температуры</li>
        <li id="pr_ul16">
          повреждения стекол/оптики, повреждения от камней из-под колес</li>
      </ul>
      <p><span style="font-weight: 700;">Дополнительные условия по программе</span></p>
      <ul>
      <li>выплата по риску ДТП без документов дорожной полиции, при ущербе до  500 000 тенге при отсутствии вины третьих лиц или при отсутствии причинения вреда жизни и здоровью людей на территории Республики Казахстан и Киргизской Республики.</li>
      <li>при частичном повреждении размер ущерба определяется на основании счета, предоставленного специализированной СТО, являющейся официальным дилером, входящим в группу компаний «Астана Моторс», при этом амортизационный износ транспортного средства в расчет не принимается.</li>
      <p><span style="font-weight: 700;">Срок действия Договора</span>&nbsp;12 месяцев, до исчерпания
        страховой суммы</p>`,
      business: 'Программа 3',
      businessHtml: `<p><strong>На страхование принимается</strong> легковой транспорт не старше 11 лет</p>
  <p><span style="font-weight: 700;">Страховым случаем является</span>&nbsp;риск утраты (гибели) или
    повреждения ТС в результате:</p>
  <ul>
    <li id="pr_ul11">дорожно-транспортное происшествие (ДТП)</li>
    <li id="pr_ul12">
      противоправные действия третьих лиц</li>
    <li id="pr_ul13">
      стихийные бедствия</li>
    <li id="pr_ul14">
      иные непредвиденные события</li>
    <li id="pr_ul15">
      случайное внешнее воздействие химических веществ/высокой температуры</li>
    <li id="pr_ul16">
      повреждения стекол/оптики, повреждения от камней из-под колес</li>
    <li id="pr_ul17">
      кража легкосъемных деталей до 250 000 тенге 1 раз в год
    </li>
  </ul>
  <p><span style="font-weight: 700;">Дополнительные условия по программе</span></p>
  <ul>
    <li>выплата по риску ДТП без документов дорожной полиции, при ущербе
      до <strong>1 000 000 тенге при отсутствии вины третьих лиц или при отсутствии
        причинения вреда жизни и здоровью людей на территории
        Республики Казахстан и Киргизской Республики.</strong></li>
    <li>при частичном повреждении размер ущерба определяется на основании счета, предоставленного специализированной СТО, являющейся официальным дилером, входящим в группу компаний «Астана Моторс», при этом амортизационный износ транспортного средства в расчет не принимается.</li>
  </ul>
  <p><span style="font-weight: 700;">Срок действия Договора</span>&nbsp;12 месяцев, до исчерпания
    страховой суммы</p>`,
      four: 'Программа 4',
      fourHtml: `<p><strong>На страхование принимается</strong> легковой транспорт не старше 11 лет</p>
  <p><span style="font-weight: 700;">Страховым случаем является</span>&nbsp;риск утраты (гибели) или
    повреждения ТС в результате:</p>
  <ul>
    <li id="pr_ul11">дорожно-транспортное происшествие (ДТП)</li>
    <li id="pr_ul12">
      противоправные действия третьих лиц</li>
    <li id="pr_ul13">
      стихийные бедствия</li>
    <li id="pr_ul14">
      иные непредвиденные события</li>
    <li id="pr_ul15">
      случайное внешнее воздействие химических веществ/высокой температуры</li>
    <li id="pr_ul16">
      повреждения стекол/оптики, повреждения от камней из-под колес</li>
  </ul>
  <p><span style="font-weight: 700;">Дополнительные условия по программе</span></p>
  <ul>
    <li>при частичном повреждении размер ущерба определяется на основании счета, предоставленного специализированной СТО, являющейся официальным дилером, входящим в группу компаний «Астана Моторс», при этом амортизационный износ транспортного средства в расчет не принимается.</li>
  </ul>
  <p><span style="font-weight: 700;">Срок действия Договора</span>&nbsp;12 месяцев, до исчерпания
    страховой суммы</p>`,
      'Франшиза безусловная': 'Франшиза безусловная',
      five: '5-бағдарлама',
      fiveHtml: `<p><strong>Сақтандыруға қабылданады</strong> 11 жылдан үлкен емес жеңіл автокөлік.</p>

<p><span style="font-weight: 700;">Сақтандыру жағдайы</span> төмендегілердің салдарынан КҚ-ны жоғалту (оның опат болу) немесе зақымдану тәуекелі болып табылады:</p>
<ul>
  <li>жол-көлік оқиғасы (ЖКО)</li>
  <li>үшінші тұлғалардың құқыққа қайшы әрекеттері</li>
  <li>табиғи апаттар</li>
  <li>басқа күтпеген оқиғалар</li>
  <li>химиялық заттардың/жоғары температураның кездейсоқ сыртқы әсері</li>
  <li>әйнектің/оптиканың зақымдануы, доңғалақ астынан ұшқан тастардан зақымдануы</li>
  <li>250&nbsp;000 теңгеге дейін жеңіл алынатын бөлшектерді ұрлау, жылына 1 рет</li>
</ul>

<p><span style="font-weight: 700;">Бағдарлама бойынша қосымша талаптар</span></p>
<ul>
  <li>ЖКО тәуекелі бойынша төлем үшінші тұлғалардың кінәсі болмаған кезде, 1&nbsp;000&nbsp;000 теңгеге дейінгі залал кезінде немесе Қазақстан Республикасы мен Қырғыз Республикасының аумағында адамдардың өмірі мен денсаулығына зиян келтірілмеген жағдайда, жол полициясының құжаттарынсыз жүргізіледі.</li>
  <li>Ішінара бүлінген кезде, залал мөлшері «Астана Моторс» компаниялар тобына кіретін ресми дилер болып табылатын мамандандырылған ТҚС ұсынған шот негізінде айқындалады, бұл ретте көлік құралының амортизациялық тозуы есепке алынбайды.</li>
</ul>

<p><span style="font-weight: 700;">Қосымша жабдық</span></p>
<ul>
  <li>Кем өлшеу — 1&nbsp;000&nbsp;000 теңге.</li>
  <li>Бронды пленка — 2&nbsp;000&nbsp;000 теңге.</li>
  <li>Жылжымалы электр табалдырықтары — 1&nbsp;000&nbsp;000 теңге.</li>
</ul>

<p><span style="font-weight: 700;">Шарттың қолданылу мерзімі</span> 12 ай, сақтандыру сомасы таусылғанға дейін</p>
`,
    },
  },
  kz: {
    casco: {
      insured_amount_must_be: 'Сақтандыру сомасы кемінде болуы тиіс',
      insured_amount: 'Сақтандыру сомасы',
      real_value: 'Көліктің нақты құны',
      program: 'Бағдарлама',

      title: 'КАСКО автосақтандыру',
      calculator: 'Сақтандыру калькуляторы',
      'description.title': 'Сипаттамасы',
      'description.text':
        'Автокөлікті сақтандыру-әрқашан тиімді! Автокөлік иесінің көптеген тәуекелдері бар, олар оның автокөлікті басқару қабілеті мен оның жүргізу тәжірибесіне тәуелді емес. Егер сізде КАСКО полисі болса, шығындарды өз қалтаңыздан төлеудің қажеті жоқ, залалды сақтандыру компаниясы жабады.',
      vip: '1-бағдарлама',
      vipHtml: `<p><span style="font-weight: 700;">Сақтандыруға</span>&nbsp;11 жылдан үлкен емесе жеңіл автокөлік қабылданады.</p>
<p><span style="font-weight: 700;">Сақтандыру жағдайы</span>&nbsp;төмендегілердің салдарынан КҚ-ны жоғалту (оның опат
  болу) немесе зақымдану тәуекелі болып табылады:</p>
<ul>
  <li id="pr_ul11">жол-көлік оқиғасы (ЖКО)</li>
  <li id="pr_ul12">
    үшінші тұлғалардың құқыққа қайшы әрекеттері</li>
  <li id="pr_ul13">
    табиғи апаттар</li>
  <li id="pr_ul14">
    басқа күтпеген оқиғалар</li>
  <li id="pr_ul15">
    химиялық заттардың/жоғары температураның кездейсоқ сыртқы әсері</li>
</ul>
<p><span style="font-weight: 700;">Бағдарлама бойынша қосымша талаптар</span></p>
<ul>
  <li>ішінара бүлінген кезде, залал
мөлшері «Астана Моторс»
компаниялар тобына кіретін
ресми дилер болып табылатын
мамандандырылған ТҚС ұсынған
шот негізінде айқындалады, бұл
ретте көлік құралының
амортизациялық тозуы есепке
алынбайды.</li>
</ul>
<p><span style="font-weight: 700;">Шарттың қолданылу мерзімі</span>&nbsp;12 ай, сақтандыру сомасы таусылғанға дейін</p>`,
      economy: '2-бағдарлама',
      economyHtml: `<p><span style="font-weight: 700;">Сақтандыруға</span>&nbsp;11 жылдан үлкен емесе жеңіл автокөлік қабылданады.</p>
<p><span style="font-weight: 700;">Сақтандыру жағдайы</span>&nbsp;төмендегілердің салдарынан КҚ-ны жоғалту (оның опат
  болу) немесе зақымдану тәуекелі болып табылады:</p>
<ul>
  <li id="pr_ul11">жол-көлік оқиғасы (ЖКО)</li>
  <li id="pr_ul12">
    үшінші тұлғалардың құқыққа қайшы әрекеттері
  </li>
  <li id="pr_ul13">
    табиғи апаттар
  </li>
  <li id="pr_ul14">
    басқа күтпеген оқиғалар
  </li>
  <li id="pr_ul15">
    химиялық заттардың/жоғары температураның кездейсоқ сыртқы әсері
  </li>
  <li id="pr_ul16">
    әйнектің/оптиканың зақымдануы, доңғалақ астынан ұшқан тастардан
    зақымдануы
  </li>
</ul>
<p><span style="font-weight: 700;">Бағдарлама бойынша қосымша талаптар</span></p>
<ul>
  <li>ЖКО тәуекелі бойынша төлем үшінші тұлғалардың кінәсі болмаған кезде, 500 000 теңгеге дейінгі залал кезінде немесе Қазақстан Республикасы мен Қырғыз Республикасының аумағында адамдардың өмірі мен денсаулығына зиян келтірілмеген жағдайда, жол полициясының құжаттарынсыз жүргізіледі.
  </li>
  <li>
  ішінара бүлінген жағдайда сақтандыру төлемін сақтандырушы мамандандырылған ТҚС-та автомобиль көлігін қалпына келтіру жолымен жүзеге асырады.
Шарттың қолданылу мерзімі 12 ай, сақтандыру сомасы таусылғанға дейін</li>
</ul>
<p><span style="font-weight: 700;">Шарттың қолданылу мерзімі</span>&nbsp;12 ай, сақтандыру сомасы таусылғанға дейін</p>`,
      business: '3-бағдарлама',
      businessHtml: `<p><span style="font-weight: 700;">Сақтандыруға</span>&nbsp;11 жылдан үлкен емесе жеңіл автокөлік қабылданады.</p>
<p><span style="font-weight: 700;">Сақтандыру жағдайы</span>&nbsp;төмендегілердің салдарынан КҚ-ны жоғалту (оның опат
  болу) немесе зақымдану тәуекелі болып табылады:</p>
<ul>
  <li id="pr_ul11">жол-көлік оқиғасы (ЖКО)</li>
  <li id="pr_ul12">
    үшінші тұлғалардың құқыққа қайшы әрекеттері
  </li>
  <li id="pr_ul13">
    табиғи апаттар
  </li>
  <li id="pr_ul14">
    басқа күтпеген оқиғалар
  </li>
  <li id="pr_ul15">
    химиялық заттардың/жоғары температураның кездейсоқ сыртқы әсері
  </li>
  <li id="pr_ul16">
    әйнектің/оптиканың зақымдануы, доңғалақ астынан ұшқан тастардан
    зақымдануы
  </li>
  <li id="pr_ul17">
    250 000 теңгеге дейін жеңіл алынатын бөлшектерді ұрлау, жылына 1 рет
  </li>
</ul>
<p><span style="font-weight: 700;">Бағдарлама бойынша қосымша талаптар</span></p>
<ul>
  <li>
    ЖКО тәуекелі бойынша төлем <strong>үшінші тұлғалардың кінәсі болмаған
    кезде, 1 000 000 теңгеге дейінгі</strong> залал кезінде <strong>немесе Қазақстан
    Республикасы мен Қырғыз Республикасының аумағында адамдардың
    өмірі мен денсаулығына зиян келтірілмеген жағдайда,</strong> жол
    полициясының құжаттарынсыз жүргізіледі.
  </li>
  <li>ішінара бүлінген кезде, залал
мөлшері «Астана Моторс»
компаниялар тобына кіретін
ресми дилер болып табылатын
мамандандырылған ТҚС ұсынған
шот негізінде айқындалады, бұл
ретте көлік құралының
амортизациялық тозуы есепке
алынбайды.
  </li>
</ul>
<p><span style="font-weight: 700;">Шарттың қолданылу мерзімі</span>&nbsp;12 ай, сақтандыру сомасы таусылғанға дейін</p>`,
      four: '4-бағдарлама',
      fourHtml: `<p><span style="font-weight: 700;">Сақтандыруға</span>&nbsp;11 жылдан үлкен емесе жеңіл автокөлік қабылданады.</p>
<p><span style="font-weight: 700;">Сақтандыру жағдайы</span>&nbsp;төмендегілердің салдарынан КҚ-ны жоғалту (оның опат
  болу) немесе зақымдану тәуекелі болып табылады:</p>
<ul>
  <li id="pr_ul11">жол-көлік оқиғасы (ЖКО)</li>
  <li id="pr_ul12">
    үшінші тұлғалардың құқыққа қайшы әрекеттері
  </li>
  <li id="pr_ul13">
    табиғи апаттар
  </li>
  <li id="pr_ul14">
    басқа күтпеген оқиғалар
  </li>
  <li id="pr_ul15">
    химиялық заттардың/жоғары температураның кездейсоқ сыртқы әсері
  </li>
  <li id="pr_ul16">
    әйнектің/оптиканың зақымдануы, доңғалақ астынан ұшқан тастардан
    зақымдануы
  </li>
</ul>
<p><span style="font-weight: 700;">Бағдарлама бойынша қосымша талаптар</span></p>
<ul>
  <li>ішінара бүлінген кезде, залал
мөлшері «Астана Моторс»
компаниялар тобына кіретін
ресми дилер болып табылатын
мамандандырылған ТҚС ұсынған
шот негізінде айқындалады, бұл
ретте көлік құралының
амортизациялық тозуы есепке
алынбайды.
  </li>
</ul>
<p><span style="font-weight: 700;">Шарттың қолданылу мерзімі</span>&nbsp;12 ай, сақтандыру сомасы таусылғанға дейін</p>`,
      'Франшиза безусловная': 'Шартсыз франшиза',
      five: '5-бағдарлама',
      fiveHtml: `<p><strong>Сақтандыруға қабылданады</strong> 11 жылдан үлкен емес жеңіл автокөлік.</p>

<p><span style="font-weight: 700;">Сақтандыру жағдайы</span> төмендегілердің салдарынан КҚ-ны жоғалту (оның опат болу) немесе зақымдану тәуекелі болып табылады:</p>
<ul>
  <li>жол-көлік оқиғасы (ЖКО)</li>
  <li>үшінші тұлғалардың құқыққа қайшы әрекеттері</li>
  <li>табиғи апаттар</li>
  <li>басқа күтпеген оқиғалар</li>
  <li>химиялық заттардың/жоғары температураның кездейсоқ сыртқы әсері</li>
  <li>әйнектің/оптиканың зақымдануы, доңғалақ астынан ұшқан тастардан зақымдануы</li>
  <li>250&nbsp;000 теңгеге дейін жеңіл алынатын бөлшектерді ұрлау, жылына 1 рет</li>
</ul>

<p><span style="font-weight: 700;">Бағдарлама бойынша қосымша талаптар</span></p>
<ul>
  <li>ЖКО тәуекелі бойынша төлем үшінші тұлғалардың кінәсі болмаған кезде, 1&nbsp;000&nbsp;000 теңгеге дейінгі залал кезінде немесе Қазақстан Республикасы мен Қырғыз Республикасының аумағында адамдардың өмірі мен денсаулығына зиян келтірілмеген жағдайда, жол полициясының құжаттарынсыз жүргізіледі.</li>
  <li>Ішінара бүлінген кезде, залал мөлшері «Астана Моторс» компаниялар тобына кіретін ресми дилер болып табылатын мамандандырылған ТҚС ұсынған шот негізінде айқындалады, бұл ретте көлік құралының амортизациялық тозуы есепке алынбайды.</li>
</ul>

<p><span style="font-weight: 700;">Қосымша жабдық</span></p>
<ul>
  <li>Кем өлшеу — 1&nbsp;000&nbsp;000 теңге.</li>
  <li>Бронды пленка — 2&nbsp;000&nbsp;000 теңге.</li>
  <li>Жылжымалы электр табалдырықтары — 1&nbsp;000&nbsp;000 теңге.</li>
</ul>

<p><span style="font-weight: 700;">Шарттың қолданылу мерзімі</span> 12 ай, сақтандыру сомасы таусылғанға дейін</p>
`,
    },
  },
  ru: {
    casco: {
      insured_amount_must_be: 'Страховая сумма должна быть от',
      insured_amount: 'Страховая сумма',
      real_value: 'Действительная стоимость ТС',
      program: 'Программа',

      title: 'КАСКО автострахование',
      calculator: 'Калькулятор страхования',
      'description.title': 'Описание',
      'description.text':
        'Страхование автотранспорта - выгодно всегда! У владельца автотранспорта множество рисков, которые не зависят от его умения управлять транспортным средством и его опыта вождения. При наличии полиса КАСКО, Вам не придется оплачивать расходы из своего кармана, ущерб покроет страховая компания.',
      vip: 'Программа 1',
      vipHtml: `<p><span style="font-weight: 700;">На страхование принимается</span>&nbsp;легковой транспорт не
      старше 11 лет</p>
    <p><span style="font-weight: 700;">Страховым случаем является</span>&nbsp;риск утраты (гибели) или
      повреждения ТС в результате:</p>
    <ul>
      <li id="pr_ul11">дорожно-транспортное происшествие (ДТП)</li>
      <li id="pr_ul12">
        противоправные действия третьих лиц</li>
      <li id="pr_ul13">
        стихийные бедствия</li>
      <li id="pr_ul14">
        иные непредвиденные события</li>
      <li id="pr_ul15">
        случайное внешнее воздействие химических веществ/высокой температуры</li>
    </ul>
    <p><span style="font-weight: 700;">Дополнительные условия по программе</span></p>
    <ul>
      <li>при частичном повреждении размер ущерба определяется на основании счета, предоставленного специализированной СТО, являющейся официальным дилером, входящим в группу компаний «Астана Моторс», при этом амортизационный износ транспортного средства в расчет не принимается.</li>
    </ul>
    <p><span style="font-weight: 700;">Срок действия Договора</span>&nbsp;12 месяцев, до исчерпания
      страховой суммы</p>`,
      economy: 'Программа 2',
      economyHtml: `<p><strong>На страхование принимается</strong> легковой транспорт не старше 11 лет</p>
<p><span style="font-weight: 700;">Страховым случаем является</span>&nbsp;риск утраты (гибели) или
  повреждения ТС в результате:</p>
<ul>
  <li id="pr_ul11">дорожно-транспортное происшествие (ДТП)</li>
  <li id="pr_ul12">
    противоправные действия третьих лиц</li>
  <li id="pr_ul13">
    стихийные бедствия</li>
  <li id="pr_ul14">
    иные непредвиденные события</li>
  <li id="pr_ul15">
    случайное внешнее воздействие химических веществ/высокой температуры</li>
  <li id="pr_ul16">
    повреждения стекол/оптики, повреждения от камней из-под колес</li>
</ul>
<p><span style="font-weight: 700;">Дополнительные условия по программе</span></p>
<ul>
<li>выплата по риску ДТП без документов дорожной полиции, при ущербе до  500 000 тенге при отсутствии вины третьих лиц или при отсутствии причинения вреда жизни и здоровью людей на территории Республики Казахстан и Киргизской Республики.</li>
<li>при частичном повреждении размер ущерба определяется на основании счета, предоставленного специализированной СТО, являющейся официальным дилером, входящим в группу компаний «Астана Моторс», при этом амортизационный износ транспортного средства в расчет не принимается.</li>
<p><span style="font-weight: 700;">Срок действия Договора</span>&nbsp;12 месяцев, до исчерпания
  страховой суммы</p>`,
      business: 'Программа 3',
      businessHtml: `<p><strong>На страхование принимается</strong> легковой транспорт не старше 11 лет</p>
<p><span style="font-weight: 700;">Страховым случаем является</span>&nbsp;риск утраты (гибели) или
  повреждения ТС в результате:</p>
<ul>
  <li id="pr_ul11">дорожно-транспортное происшествие (ДТП)</li>
  <li id="pr_ul12">
    противоправные действия третьих лиц</li>
  <li id="pr_ul13">
    стихийные бедствия</li>
  <li id="pr_ul14">
    иные непредвиденные события</li>
  <li id="pr_ul15">
    случайное внешнее воздействие химических веществ/высокой температуры</li>
  <li id="pr_ul16">
    повреждения стекол/оптики, повреждения от камней из-под колес</li>
  <li id="pr_ul17">
    кража легкосъемных деталей до 250 000 тенге 1 раз в год
  </li>
</ul>
<p><span style="font-weight: 700;">Дополнительные условия по программе</span></p>
<ul>
  <li>выплата по риску ДТП без документов дорожной полиции, при ущербе
    до <strong>1 000 000 тенге при отсутствии вины третьих лиц или при отсутствии
      причинения вреда жизни и здоровью людей на территории
      Республики Казахстан и Киргизской Республики.</strong></li>
  <li>при частичном повреждении размер ущерба определяется на основании счета, предоставленного специализированной СТО, являющейся официальным дилером, входящим в группу компаний «Астана Моторс», при этом амортизационный износ транспортного средства в расчет не принимается.</li>
</ul>
<p><span style="font-weight: 700;">Срок действия Договора</span>&nbsp;12 месяцев, до исчерпания
  страховой суммы</p>`,
      four: 'Программа 4',
      fourHtml: `<p><strong>На страхование принимается</strong> легковой транспорт не старше 11 лет</p>
<p><span style="font-weight: 700;">Страховым случаем является</span>&nbsp;риск утраты (гибели) или
  повреждения ТС в результате:</p>
<ul>
  <li id="pr_ul11">дорожно-транспортное происшествие (ДТП)</li>
  <li id="pr_ul12">
    противоправные действия третьих лиц</li>
  <li id="pr_ul13">
    стихийные бедствия</li>
  <li id="pr_ul14">
    иные непредвиденные события</li>
  <li id="pr_ul15">
    случайное внешнее воздействие химических веществ/высокой температуры</li>
  <li id="pr_ul16">
    повреждения стекол/оптики, повреждения от камней из-под колес</li>
</ul>
<p><span style="font-weight: 700;">Дополнительные условия по программе</span></p>
<ul>
  <li>при частичном повреждении размер ущерба определяется на основании счета, предоставленного специализированной СТО, являющейся официальным дилером, входящим в группу компаний «Астана Моторс», при этом амортизационный износ транспортного средства в расчет не принимается.</li>
</ul>
<p><span style="font-weight: 700;">Срок действия Договора</span>&nbsp;12 месяцев, до исчерпания
  страховой суммы</p>`,
      'Франшиза безусловная': 'Франшиза безусловная',

      five: 'Программа 5',
      fiveHtml: `<p><strong>На страхование принимается</strong> легковой транспорт не старше 11 лет</p>

<p><span style="font-weight: 700;">Страховым случаем является</span> риск утраты (гибели) или повреждения ТС в результате:</p>
<ul>
  <li>дорожно-транспортное происшествие (ДТП)</li>
  <li>противоправные действия третьих лиц</li>
  <li>стихийные бедствия</li>
  <li>иные непредвиденные события</li>
  <li>случайное внешнее воздействие химических веществ/высокой температуры</li>
  <li>повреждения стекол/оптики, повреждения от камней из-под колес</li>
  <li>кража легкосъемных деталей до 250&nbsp;000 тенге 1 раз в год</li>
</ul>

<p><span style="font-weight: 700;">Дополнительные условия по программе</span></p>
<ul>
  <li>выплата по риску ДТП без документов дорожной полиции, при ущербе до 1&nbsp;000&nbsp;000 тенге при отсутствии вины третьих лиц или при отсутствии причинения вреда жизни и здоровью людей на территории Республики Казахстан и Киргизской Республики.</li>
  <li>при частичном повреждении размер ущерба определяется на основании счета, предоставленного специализированной СТО, являющейся официальным дилером, входящим в группу компаний «Астана Моторс», при этом амортизационный износ транспортного средства в расчет не принимается.</li>
</ul>

<p><span style="font-weight: 700;">Дополнительное оборудование</span></p>
<ul>
  <li>Обвес — лимит 1&nbsp;000&nbsp;000 тенге.</li>
  <li>Бронеплёнка — 2&nbsp;000&nbsp;000 тенге.</li>
  <li>Выдвижные электрические пороги — 1&nbsp;000&nbsp;000 тенге.</li>
</ul>

<p><span style="font-weight: 700;">Срок действия Договора</span> 12 месяцев, до исчерпания страховой суммы</p>`,
    },
  },
};

export default cascoResources;
